import React, { useState } from "react";
import EmployeeDetails from "./EmployeeDetails";
import PersonalDetails from "./PersonalDetails";
import BankDetails from "./BankDetails";
import EmployeeDocument from "./EmployeeDocument";
import EmployeeFinanceDetails from "./EmployeeFinanceDetails";
import EmployeeLeave from "./EmployeeLeave";
import EmployeeServiceBook from "./EmployeeServiceBook";

const AddEmployeeModal = ({
  isVisible,
  onClose,
  employeeDetails,
  setEmployeeDetails,
  isEdit,
  EmpId,
}) => {
  const [activeTab, setActiveTab] = useState("employee");

  const renderActiveTab = () => {
    switch (activeTab) {
      case "employee":
        return <EmployeeDetails EmpId={EmpId} onClose={onClose} />;
      case "personal":
        return <PersonalDetails EmpId={EmpId} onClose={onClose} />;
      case "finance":
        return <EmployeeFinanceDetails EmpId={EmpId} onClose={onClose} />;
        case "Leave":
          return <EmployeeLeave EmpId={EmpId} onClose={onClose}/>;
      case "bank":
        return <BankDetails EmpId={EmpId} onClose={onClose} />;
      case "documents":
        return <EmployeeDocument EmpId={EmpId} onClose={onClose} />;
        case "servicebook":
          return <EmployeeServiceBook EmpId={EmpId} onClose={onClose} />;
      default:
        return null;
    }
  };

  return isVisible ? (
    <div className=" w-[80%]">
      <div className="modal-container bg-white rounded-lg p-5 shadow-lg">
        <div className="flex border-b border-border mb-5">
          <button
            className={`flex-1 py-3 ${activeTab === "employee"
                ? "bg-primary text-white"
                : "bg-bg-light text-gray-500"
              }`}
            onClick={() => setActiveTab("employee")}
          >
            Employee Details
          </button>
          {isEdit && (
            <button
              className={`flex-1 py-3 ${activeTab === "personal"
                  ? "bg-primary text-white"
                  : "bg-bg-light text-gray-500"
                }`}
              onClick={() => setActiveTab("personal")}
            >
              Personal Details
            </button>
          )}

          {isEdit && (
            <button
              className={`flex-1 py-3 ${activeTab === "finance"
                  ? "bg-primary text-white"
                  : "bg-bg-light text-gray-500"
                }`}
              onClick={() => setActiveTab("finance")}
            >
              Finance Details
            </button>
          )}
          {isEdit && (
            <button
              className={`flex-1 py-3 ${activeTab === "Leave"
                  ? "bg-primary text-white"
                  : "bg-bg-light text-gray-500"
                }`}
              onClick={() => setActiveTab("Leave")}
            >
              Leave Details
            </button>
          )}
          {isEdit && (
            <button
              className={`flex-1 py-3 ${activeTab === "bank"
                  ? "bg-primary text-white"
                  : "bg-bg-light text-gray-500"
                }`}
              onClick={() => setActiveTab("bank")}
            >
              Bank Details
            </button>
          )}
          {isEdit && (
            <button
              className={`flex-1 py-3 ${activeTab === "documents"
                  ? "bg-primary text-white"
                  : "bg-bg-light text-gray-500"
                }`}
              onClick={() => setActiveTab("documents")}
            >
              Documents
            </button>
          )}
           {isEdit && (
            <button
              className={`flex-1 py-3 ${activeTab === "servicebook"
                  ? "bg-primary text-white"
                  : "bg-bg-light text-gray-500"
                }`}
              onClick={() => setActiveTab("servicebook")}
            >
              Service Book
            </button>
          )}

          <button
            onClick={onClose}
            className="btn flex items-center justify-center text-red-500"
          >
            ✖
          </button>
        </div>
        <div className="tab-content">{renderActiveTab()}</div>
      </div>
    </div>
  ) : null;
};

export default AddEmployeeModal;
